import { useContext, useEffect } from 'react'
import { HeaderActionsContext } from 'widgets/Header/context/headerActionsContext'

export const useHeaderLeading = leadingNode => {
	const { setHeaderLeading } = useContext(HeaderActionsContext)

	useEffect(() => {
		setHeaderLeading?.(leadingNode)
		return () => setHeaderLeading?.(null)
	}, [leadingNode, setHeaderLeading])
}
